import {
	Badge,
	Box,
	Icons,
	Inline,
	Stack,
	Text,
	Tooltip,
	Button,
} from "@sembark-travel/ui-base"
import { TWhatsAppThread } from "../store"
import { WhatsAppContactAvatar } from "./ContactAvatar"

// The conversation header: avatar, contact identity and the sender channel.
// `actions` renders on the right (e.g. the follow toggle on the trip page).
export function WhatsAppConversationHeader({
	thread,
	actions,
}: {
	thread: TWhatsAppThread
	actions?: React.ReactNode
}) {
	return (
		<Inline
			gap="3"
			alignItems="center"
			justifyContent="between"
			paddingX="4"
			paddingY="3"
			borderBottomWidth="1"
			bgColor="default"
		>
			<Inline gap="3" alignItems="center" style={{ minWidth: 0 }}>
				<WhatsAppContactAvatar
					name={thread.contact?.name}
					number={thread.contact?.contact_number}
				/>
				<Stack gap="px" style={{ minWidth: 0 }}>
					<Inline gap="2" alignItems="center" flexWrap="wrap">
						<Text fontWeight="semibold">
							{thread.contact?.name ||
								thread.contact?.contact_number ||
								"Customer"}
						</Text>
						{thread.contact?.identity_changed_at ? (
							<Badge
								status="warning"
								title="The recipient's WhatsApp identity changed; this conversation is sealed."
							>
								Identity changed
							</Badge>
						) : null}
						{thread.referral ? (
							// The customer opened this conversation from an ad or
							// post: that is where the lead came from.
							<Badge
								title={[
									thread.referral.headline,
									thread.referral.source_id
										? `${thread.referral.source_type || "source"} ${thread.referral.source_id}`
										: null,
								]
									.filter(Boolean)
									.join(" · ")}
							>
								From {thread.referral.source_type === "post" ? "post" : "ad"}
								{thread.referral.headline
									? ` · ${thread.referral.headline}`
									: ""}
							</Badge>
						) : null}
					</Inline>
					<Inline gap="2" alignItems="center" flexWrap="wrap">
						{thread.contact?.contact_number ? (
							<Text fontSize="sm" color="muted">
								{thread.contact.contact_number}
							</Text>
						) : null}
						{thread.contact?.username ? (
							<Text fontSize="sm" color="muted">
								@{thread.contact.username}
							</Text>
						) : null}
						<Tooltip
							interactive
							content={
								<Text
									title={
										thread.phone_number?.wa_business_account?.name ||
										"WhatsApp Business Account"
									}
									fontSize="sm"
								>
									{thread.phone_number?.display_phone_number
										? `Your Business Account: ${thread.phone_number.display_phone_number}`
										: "WABA"}
								</Text>
							}
						>
							<Button inline>
								<Icons.ChevronDown />
							</Button>
						</Tooltip>
					</Inline>
				</Stack>
			</Inline>
			{actions ? <Box flexShrink="0">{actions}</Box> : null}
		</Inline>
	)
}
